"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Button;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _ButtonTitle = _interopRequireDefault(require("./ButtonTitle"));
var _excluded = ["title", "style", "disabled", "titleStyle", "disabledStyle", "disabledTitleStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import {
//   useActive,
//   useHover
// } from 'react-native-web-hooks';

function Button(props) {
  var title = props.title,
    style = props.style,
    disabled = props.disabled,
    titleStyle = props.titleStyle,
    disabledStyle = props.disabledStyle,
    disabledTitleStyle = props.disabledTitleStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);

  // const ref = useRef(null);
  // const { isHovered } = useHover(ref);

  var buttonStyles = [styles.button, style, disabled && styles.disabled, disabled && disabledStyle
  // isHovered && styles.hovered,
  // isHovered && hoveredStyle
  ];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity
  // ref={ref}
  , (0, _extends2["default"])({
    style: buttonStyles,
    disabled: disabled,
    accessibilityRole: "button"
  }, rest), /*#__PURE__*/_react["default"].createElement(_ButtonTitle["default"], {
    disabled: disabled,
    style: titleStyle,
    disabledStyle: disabledTitleStyle
  }, title));
}
Button.defaultProps = Button.defaultProps || {};
Button.defaultProps.allowFontScaling = false;
Button.propTypes = {
  title: _propTypes["default"].any.isRequired,
  disabled: _propTypes["default"].bool,
  onPress: _propTypes["default"].func,
  style: _propTypes["default"].any,
  titleStyle: _propTypes["default"].any,
  disabledStyle: _propTypes["default"].any,
  disabledTitleStyle: _propTypes["default"].any
};
var styles = _reactNative.StyleSheet.create({
  button: _objectSpread(_objectSpread({
    justifyContent: 'center',
    alignItems: 'center'
  }, _styles.sizes.selectStyleByDefaultSize({
    small: {
      paddingTop: 3,
      paddingBottom: 5,
      paddingLeft: 24,
      paddingRight: 24
      // marginTop: 8,
      // marginBottom: 8,
    },
    medium: {
      paddingTop: 7,
      paddingBottom: 9,
      paddingLeft: 24,
      paddingRight: 24
      // marginTop: 4,
      // marginBottom: 4,
    },
    large: {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 24,
      paddingRight: 24
    }
  })), {}, {
    backgroundColor: _styles.backgroundColors.feature,
    borderRadius: 4
  }),
  disabled: {
    backgroundColor: _styles.backgroundColors.trivial
  }
  // hovered: {
  //   backgroundColor: backgroundColors.focus,
  // }
});